import React from 'react';
import Slider from "react-slick";
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import { NavLink } from "react-router-dom";


export default function Blogs() {


    const blogs = {
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        autoplay: false,
        arrows: true,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,

        prevArrow: <IoArrowBack className="icofont-arrow-right dandik" />,
        nextArrow: <IoArrowForward className="icofont-arrow-left bamdik" />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                   
                }
            },
        ]
    };
    return (
        <Slider {...blogs} className="blog-slider slider-arrow">
            <div className="blog-card">
                <div className="blog-media">
                    <NavLink className="blog-img" href="#">
                        <img src="assets/images/elements/chinar.jpg" className='w-100' alt="blog" />
                    </NavLink>
                </div>
                <div className="blog-content">
                    <ul className="blog-meta">
                        <li>
                            <i className="fas fa-user"></i>
                            <span>admin 1</span>
                        </li>
                        <li>
                            <i className="fas fa-calendar-alt"></i>
                            <span>February 02, 2021</span>
                        </li>
                    </ul>
                    <h4 className="blog-title">
                        <NavLink href="#">Voluptate blanditiis provident Lorem ipsum dolor sit amet</NavLink>
                    </h4>
                    <p className="blog-desc">
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias autem recusandae deleniti nam dignissimos sequi ...
                    </p>
                </div>
            </div>
            <div className="blog-card">
                <div className="blog-media">
                    <NavLink className="blog-img" href="#">
                        <img src="assets/images/elements/chinar.jpg" className='w-100' alt="blog" />
                    </NavLink>
                </div>
                <div className="blog-content">
                    <ul className="blog-meta">
                        <li>
                            <i className="fas fa-user"></i>
                            <span>admin 2</span>
                        </li>
                        <li>
                            <i className="fas fa-calendar-alt"></i>
                            <span>February 02, 2021</span>
                        </li>
                    </ul>
                    <h4 className="blog-title">
                        <NavLink href="#">Voluptate blanditiis provident Lorem ipsum dolor sit amet</NavLink>
                    </h4>
                    <p className="blog-desc">
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias autem recusandae deleniti nam dignissimos sequi ...
                    </p>
                </div>
            </div>
            <div className="blog-card">
                <div className="blog-media">
                    <NavLink className="blog-img" href="#">
                        <img src="assets/images/elements/chinar.jpg" className='w-100' alt="blog" />
                    </NavLink>
                </div>
                <div className="blog-content">
                    <ul className="blog-meta">
                        <li>
                            <i className="fas fa-user"></i>
                            <span>admin 3</span>
                        </li>
                        <li>
                            <i className="fas fa-calendar-alt"></i>
                            <span>February 02, 2021</span>
                        </li>
                    </ul>
                    <h4 className="blog-title">
                        <NavLink href="#">Voluptate blanditiis provident Lorem ipsum dolor sit amet</NavLink>
                    </h4>
                    <p className="blog-desc">
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias autem recusandae deleniti nam dignissimos sequi ...
                    </p>
                </div>
            </div>
            <div className="blog-card">
                <div className="blog-media">
                    <NavLink className="blog-img" href="#">
                        <img src="assets/images/elements/chinar.jpg" className='w-100' alt="blog" />
                    </NavLink>
                </div>
                <div className="blog-content">
                    <ul className="blog-meta">
                        <li>
                            <i className="fas fa-user"></i>
                            <span>admin 4</span>
                        </li>
                        <li>
                            <i className="fas fa-calendar-alt"></i>
                            <span>February 02, 2021</span>
                        </li>
                    </ul>
                    <h4 className="blog-title">
                        <NavLink href="#">Voluptate blanditiis provident Lorem ipsum dolor sit amet</NavLink>
                    </h4>
                    <p className="blog-desc">
                        Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias autem recusandae deleniti nam dignissimos sequi ...
                    </p>
                </div>
            </div>
        </Slider>
    )
}
